module.exports = __webpack_public_path__ + "img/iconArrowNavyDropDown.451cbbcf.svg";